import { Injectable } from '@angular/core';

import { LocalStorageService } from '@main-client/src/app/core/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageCheckerService {
  constructor(private localStorage: LocalStorageService) {}

  hasLocalStorage() {
    let hasLocalStorage = true;
    try {
      const key = 'ttc-test';
      this.localStorage.setItem(key, 'test');
      this.localStorage.removeItem(key);
    } catch (e) {
      hasLocalStorage = false;
    }
    return hasLocalStorage;
  }
}
